package components.company.pricelist

import it.neckar.react.common.*
import it.neckar.react.common.router.*
import react.*
import react.dom.*
import react.router.*
import router.useDocumentTitle
import store.hooks.useRequireCompanyForLoggedInUser


val PriceListFromUrl: FC<Props> = fc("PriceListFromUrl") {
  val companyName = useRequireCompanyForLoggedInUser().simpleName

  useDocumentTitle(companyName, "Preisliste")


  div {

    h2 {
      +"Preisliste"
    }

    div("mt-5") {
      tabButtonsPane {

        tabButton(PriceListTabs.modules, "Module")
        tabButton(PriceListTabs.inverters, "Wechselrichter")
        tabButton(PriceListTabs.hybridInverters, "Hybrid-Wechselrichter")
        tabButton(PriceListTabs.batteries, "Batteriespeicher")
        tabButton(PriceListTabs.batteryConfigurations, "Batteriespeicher-Systeme")
        tabButton(PriceListTabs.roofTypes, "Dachtypen")
        tabButton(PriceListTabs.roofIsolation, "Aufdachdämmung")
        tabButton(PriceListTabs.metalRoofTiles, "Metalldachziegel")
        tabButton(PriceListTabs.facilityAndAssembly, "Anlage & Montage")
        tabButton(PriceListTabs.independenceManagers, "Ersatzstromsysteme")
        tabButton(PriceListTabs.wallboxes, "Wallbox")
        tabButton(PriceListTabs.monitoring, "Monitoring")
        tabButton(PriceListTabs.miscellaneous, "Sonstiges")

      }
    }

    div("mt-5") {
      Outlet {}
    }

  }
}

object PriceListTabs {
  val modules: NavigateUrl = NavigateUrl("modules")
  val inverters: NavigateUrl = NavigateUrl("inverters")
  val hybridInverters: NavigateUrl = NavigateUrl("hybrid-inverters")
  val batteries: NavigateUrl = NavigateUrl("batteries")
  val batteryConfigurations: NavigateUrl = NavigateUrl("battery-configurations")
  val roofTypes: NavigateUrl = NavigateUrl("roof-types")
  val roofIsolation: NavigateUrl = NavigateUrl("roof-isolation")
  val metalRoofTiles: NavigateUrl = NavigateUrl("metal-roof-tiles")
  val facilityAndAssembly: NavigateUrl = NavigateUrl("facility-and-assembly")
  val independenceManagers: NavigateUrl = NavigateUrl("independence-managers")
  val wallboxes: NavigateUrl = NavigateUrl("wallboxes")
  val monitoring: NavigateUrl = NavigateUrl("monitoring")
  val miscellaneous: NavigateUrl = NavigateUrl("miscellaneous")
}

fun RBuilder.dataSheetLink(dataSheetPath: String) {
  a(href = "/dataSheets/$dataSheetPath", target = "_blank") {
    attrs {
      type = "application/pdf"
    }
    i(classes = FontAwesomeIcons.pdfFile) {}
  }
}
